import api from 'apis/restaurant-api/api';

import { DepositPermutation } from './types';

export const readDeposits = (countryCode: string) =>
  api
    .get<DepositPermutation[]>('v1/merchant-admin/deposit_permutations', {
      params: { country: countryCode },
    })
    .then(response => response.data);
